import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'absolute',
  standalone: false,
})
@Injectable({ providedIn: 'root' })
export class AbsolutePipe implements PipeTransform {
  transform(value: number): number {
    if (value == undefined) {
      return;
    }

    return Math.abs(value);
  }
}
